import { BooleanField, NumberField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import type { FollowUpSendTo, FollowUpTimeUnit, IFollowUpRelated } from '@/data/models/domain/types'

@OrmModel(modelNames.FOLLOW_UP)
export default class FollowUp extends BaseModel implements IFollowUpRelated {
  @NumberField()
  public sendAfter: number

  @StringField()
  public sendAfterUnit: FollowUpTimeUnit

  @StringField()
  public sendTo: FollowUpSendTo

  @BooleanField()
  public setDifferentSubject: boolean

  @StringField(null)
  public emailSubject: string | null

  @StringField(null)
  public previewText: string | null

  @StringField(null)
  public relatedEmailCampaignId: string | null

  @StringField(null)
  public relatedScheduledEmailCampaignId: string | null
}
